export default __webpack_public_path__ + "static/media/withdrawals.df384e66.svg";